<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/156wre0/tc-custom/9781460351918.jpg?1728726639676" alt="This image is the cover for the book Get Lucky, Tall, Dark and Dangerous"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Get Lucky, Tall, Dark and Dangerous
      </h1>
      <p class="bookDescription body article font2">
        <b>A Navy SEAL teams up with a feisty journalist to catch a dangerous criminal in the <i>New York Times</i>–bestselling author’s thrilling military romance.</b><br/><br/>While the men of Alpha Squad deploy on a dangerous mission, Luke “Lucky” O’Donlon stays behind for his sister’s wedding. But it turns out his elite skills are needed at home—when a serial rapist starts terrorizing San Felipe. Suspecting the culprit might be a SEAL, Lucky joins a local task force to unmask the menace. And that’s when he meets journalist Sydney Jameson . . . <br/><br/>Sydney isn’t the typical arm candy Lucky goes for, but he’s used to women swooning at his feet. So why does this smart, no-nonsense reporter seem immune to his charms? As they work together on their dangerous assignment, Lucky is determined to turn her frosty attitude around—and make her fall head over heels for him.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Suzanne Brockmann
      </h2>
      
      <p class="authorDescription body article">Suzanne Brockmann is an award-winning author of more than fifty books and is widely recognized as one of the leading voices in romantic suspense. Her work has earned her repeated appearances on the New York Times bestseller list, as well as numerous awards, including Romance Writers of America&rsquo;s #1 Favorite Book of the Year and two RITA awards. Suzanne divides her time between Siesta Key and Boston. Visit her at www.SuzanneBrockmann.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b047203